import Actions                   from 'Redux/Actions';
import { EventTicketRepository } from 'Domain/Repositories';
import { ofType }                from 'redux-observable';
import { from }                  from 'rxjs';
import { mergeMap }              from 'rxjs/operators';
import { TEpic }                 from 'Redux/Config';

export const findEventTicketsEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.findEventTicketsRequest.type),
    mergeMap(action => from(
      EventTicketRepository.findAll(action.payload)
        .then(({ eventTickets, meta }) => Actions.findEventTicketsSuccess({ eventTickets, maxCount: meta?.count }))
        .catch((error: Error) => Actions.findEventTicketsFailure({ error })),
    )),
  );
};
